import React from 'react';
import _ from 'lodash';
import { Modal } from 'reactstrap';
import Webcam from 'react-webcam';
import Button from 'components/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCircle } from '@fortawesome/free-solid-svg-icons';
import './camera.scss';

const dataURLtoFile = dataUrl => {
  if (dataUrl) {
    let arr = dataUrl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File(
      [u8arr],
      `${new Date().getTime().toString()}.${mime.split('/')[1]}`,
      {
        type: mime,
      }
    );
  }
};

export default ({ isOpen, toggle, capture }) => {
  const webcamRef = React.useRef(null);
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="app-camera-modal">
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        videoConstraints={{
          facingMode: 'environment',
        }}
      />
      <Button
        type="cancel"
        handleClick={() => _.isFunction(toggle) && toggle()}
      >
        <FontAwesomeIcon icon={faTimes} />
      </Button>
      <Button
        type="capture"
        handleClick={() => {
          const imageSrc = webcamRef.current.getScreenshot();
          if (imageSrc) {
            const file = dataURLtoFile(imageSrc);
            _.isFunction(capture) && capture(file);
          }
        }}
      >
        <FontAwesomeIcon icon={faCircle} />
      </Button>
    </Modal>
  );
};
